import { createContext } from "react";

export type GlobalAnalysisNotificationsContextType = {
  activeAnalyses: string[];
  addAnalysis: (url: string) => void;
  removeAnalysis: (url: string) => void;
};

export const GlobalAnalysisNotificationsContext =
  createContext<GlobalAnalysisNotificationsContextType | null>(null);
